import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {
  isEmpty, get, map, find, trim,
} from 'lodash';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Select,
  Message,
  Table,
  Label,
} from 'semantic-ui-react';
import dealerNumbersQuery from '../../graphql/dealerNumbersQuery';
import filteredFlatRatesQuery from '../../graphql/filteredFlatRatesQuery';
import FlatRatesList from './FlatRatesList';

import productMasterQuery from '../../graphql/productMasterQuery';
import { enrollableProductTypes } from '../../constants/product';

function checkDealer(dealers, dealer) {
  const index = dealers.indexOf(find(dealers, ['id', dealer.id]));
  let newDealerObject = { ...dealer };
  newDealerObject = Object.assign(newDealerObject, { selected: true });
  dealers[index] = newDealerObject;
  return dealers;
}

function unCheckDealer(dealers, dealer) {
  const index = dealers.indexOf(find(dealers, ['id', dealer.id]));
  let newDealerObject = { ...dealer };
  newDealerObject = Object.assign(newDealerObject, { selected: false });
  dealers[index] = newDealerObject;
  return dealers;
}

class NewFlatRateOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auctionAccessNumber: '',
      govtLast4: '',
      externalUser: false,
      dealers: null,
      noDealersForAuction: false,
      selectedDealerNumbers: [],
      allDealersSelected: false,
      milesSelected: 360,
      daysSelected: 21,
      psiEligible: false,
      daysPsi: null,
      flatRates: null,
      selectedflatRates: [],
      buyerInformation: null,
      formError: null,
      submitting: false,
      productSelected: null,
      productId: null,
      protductType: null,
      productName: null,
      palv: false,
    };

    this.onSearchByDealerHandler = this.onSearchByDealerHandler.bind(this);
    this.onSearchByAuctionAccessHandler = this.onSearchByAuctionAccessHandler.bind(this);
  }

  onSearchByDealerHandler(e) {
    e.preventDefault();
    const {
      auctionAccessNumber,
      govtLast4,
      selectedDealerNumbers,
      milesSelected,
      psiEligible,
      daysSelected,
      daysPsi,
      palv,
      productSelected,
    } = this.state;
    if (!isEmpty(selectedDealerNumbers) && productSelected !== null) {
      const { client } = this.props;
      this.setState({
        formError: null,
        flatRates: null,
        buyerInformation: null,
        submitting: true,
      });
      client
        .query({
          query: filteredFlatRatesQuery,
          variables: {
            auctionAccessNumber: parseInt(auctionAccessNumber, 10),
            dealerNumbers: selectedDealerNumbers,
            miles: milesSelected,
            psi: +psiEligible,
            daysSelected,
            govtLast4: trim(govtLast4),
            daysPsi,
            lv: +palv,
          },
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          const flatRates = get(data, 'apmsFlatRates');
          const buyerInformation = get(data, 'buyerInformation');
          // US1619216 Pricing for PSI offers sent
          this.setState({
            flatRates: this.processFlatRate(flatRates),
            buyerInformation,
            submitting: false,
          });
        })
        .catch(() => {
          this.setState({
            formError: 'No 360 rate available',
            submitting: false,
          });
        });
    } else {
      this.setState({
        formError: 'Please select atleast one dealer and product',
        submitting: false,
      });
    }
  }

  processFlatRate(flatRates) {
    const { daysPsi, milesSelected, productType } = this.state;

    if (daysPsi && flatRates) {
      return flatRates.map(flatRate => ({
        ...flatRate,
        targetPrice: flatRate[`targetPrice${milesSelected}`],
        psiBundlePrice:
          flatRate[`targetPrice${milesSelected}Psi`]
          + (daysPsi === 14 ? 30 : 0),
      }));
    }
    if (!enrollableProductTypes.includes(productType)) {
      return flatRates.map(flatRate => ({
        ...flatRate,
        targetPrice: 0,
        psiBundlePrice: 0,
      }));
    }
    return flatRates;
  }

  onSearchByAuctionAccessHandler(e) {
    e.preventDefault();
    const { govtLast4 } = e.target;
    const { client } = this.props;
    const { auctionAccessNumber } = this.state;
    const trimmedAuctionAccessNumber = auctionAccessNumber.replace(/\s+/g, '');

    if (!isEmpty(trimmedAuctionAccessNumber)) {
      this.setState({
        dealers: null,
        flatRates: null,
        buyerInformation: null,
        selectedDealerNumbers: [],
        allDealersSelected: null,
        submitting: true,
      });
      const govtLast4Value = govtLast4 ? govtLast4.value : null;
      client
        .query({
          query: dealerNumbersQuery,
          variables: {
            auctionAccessNumber: trimmedAuctionAccessNumber,
            govtLast4: govtLast4Value,
          },
        })
        .then(({ data }) => {
          const dealerAccounts = get(data, 'dealerAccounts');
          if (!isEmpty(dealerAccounts)) {
            this.setState({
              dealers: dealerAccounts,
              noDealersForAuction: false,
              submitting: false,
            });
          } else {
            this.setState({
              dealers: null,
              noDealersForAuction: true,
              submitting: false,
            });
          }
        })
        .catch(() => {});
    }
  }

  selectProduct(id) {
    const { data } = this.props;
    const products = get(data, 'products');
    if (products) {
      return find(products, ['productId', id]);
    }
    return null;
  }

  getProduct() {
    const { data: products } = this.props;
    let selectedProducts = [];

    if (!isEmpty(products) && products.products) {
      selectedProducts = products.products
        .filter(product => enrollableProductTypes.includes(product.productType))
        .map(product => ({
          key: product.productId,
          value: product.productId,
          text: product.productType,
        }));
    }
    return selectedProducts;
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      dealers,
      noDealersForAuction,
      flatRates,
      auctionAccessNumber,
      palv,
      formError,
      externalUser,
      govtLast4,
      allDealersSelected,
      productSelected,
      milesSelected,
      daysSelected,
      psiEligible,
      daysPsi,
      selectedflatRates,
      buyerInformation,
      productId,
      protductType,
      productName,
      submitting: stateSubmitting,
    } = this.state;

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
    };

    const onSelectProductHandler = () => (event, data) => {
      const product = this.selectProduct(data.value);
      if (product) {
        this.setState({
          milesSelected: product.mileDs,
          daysSelected: product.daysDs,
          daysPsi: product.daysPsi,
          psiEligible: !!product.daysPsi,
          productId: product.productId,
          productSelected: data.value,
          productType: product.productType,
          productName: product.productDescription,
        });

        if (product.daysPsi) {
          this.setState({ palv: false });
        }
      }
    };

    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const onDealerCheckboxHandler = () => (event, data) => {
      this.setState(prevState => {
        const selectedDealerNumbers = [...prevState.selectedDealerNumbers];
        let currentDealers = [...prevState.dealers];
        const dealer = { ...find(currentDealers, ['id', data.value]) };

        if (data.checked) {
          if (!selectedDealerNumbers.includes(data.value)) {
            selectedDealerNumbers.push(data.value);
          }
          currentDealers = checkDealer(currentDealers, dealer);
        } else {
          const index = selectedDealerNumbers.indexOf(data.value);
          if (index > -1) {
            selectedDealerNumbers.splice(index, 1);
          }
          currentDealers = unCheckDealer(currentDealers, dealer);
        }
        return { selectedDealerNumbers, allDealersSelected: false, dealers: currentDealers };
      });
    };

    const onallDealersCheckboxHandler = () => (event, data) => {
      this.setState(prevState => {
        let selectedDealerNumbers = [];
        let allDealersSelectedState = false;
        let currentDealers = [...prevState.dealers];

        if (data.checked) {
          selectedDealerNumbers = currentDealers.map(dealer => dealer.id);
          currentDealers = currentDealers.map(dealer => ({ ...dealer, selected: true }));
          allDealersSelectedState = true;
        } else {
          currentDealers = currentDealers.map(dealer => ({ ...dealer, selected: false }));
          allDealersSelectedState = false;
        }
        return { selectedDealerNumbers, allDealersSelected: allDealersSelectedState, dealers: currentDealers };
      });
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
        size='large'
      >
        <Modal.Header>Create 360 Offer</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            <Form onSubmit={this.onSearchByAuctionAccessHandler}>
              <Form.Group widths='4'>
                <Form.Field>
                  <label htmlFor='auctionAccessNumber'>Auction Access # [100M]</label>
                  <Form.Input
                    id='auctionAccessNumber'
                    name='auctionAccessNumber'
                    placeholder='Please Enter Auction Access # [100M]'
                    onChange={onSelectHandler('auctionAccessNumber')}
                    value={auctionAccessNumber}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor='externalUser'>External User</label>
                  <Checkbox
                    id='externalUser'
                    name='externalUser'
                    checked={externalUser}
                    onChange={onCheckboxHandler('externalUser')}
                  />
                </Form.Field>
                {externalUser && (
                  <Form.Field>
                    <label htmlFor='govtLast4'>Govt. ID Last4</label>
                    <Form.Input
                      id='govtLast4'
                      name='govtLast4'
                      placeholder='Please Enter Govt Last4'
                      onChange={onSelectHandler('govtLast4')}
                      value={govtLast4}
                    />
                  </Form.Field>
                )}
                <Form.Field>
                  <br />
                  <Form.Button color='green' inverted>
                    Search
                  </Form.Button>
                </Form.Field>
              </Form.Group>
            </Form>
            {formError && (
              <Message negative>
                <p>{formError}</p>
              </Message>
            )}
            {!isEmpty(dealers) && (
              <Form onSubmit={this.onSearchByDealerHandler}>
                <br />
                <br />
                <Label>Select Dealer(s)</Label>
                <Table celled padded size='small'>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>
                        <Checkbox
                          checked={allDealersSelected}
                          onChange={onallDealersCheckboxHandler(
                            'allDealersSelected'
                          )}
                        />
                      </Table.HeaderCell>
                      <Table.HeaderCell>Dealer Number</Table.HeaderCell>
                      <Table.HeaderCell>Dealer Name</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {map(dealers, dealer => (
                      <Table.Row key={dealer.id}>
                        <Table.Cell>
                          <Checkbox
                            value={dealer.id}
                            checked={dealer.selected}
                            onChange={onDealerCheckboxHandler(
                              'selectedDealerNumbers'
                            )}
                          />
                        </Table.Cell>
                        <Table.Cell>{dealer.id}</Table.Cell>
                        <Table.Cell>{dealer.name}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                <br />
                <br />
                <Form.Group>
                  <Form.Field width={8}>
                    <Label htmlFor='productSelected'>Select Product</Label>
                    <br />
                    <br />
                    <Select
                      id='productSelected'
                      fluid
                      placeholder='Select Product'
                      options={this.getProduct()}
                      closeOnBlur
                      value={productSelected}
                      onChange={onSelectProductHandler('product')}
                    />
                  </Form.Field>
                </Form.Group>
                <br />
                <br />
                <Form.Group>
                  <Form.Field>
                    <Form.Button color='green' inverted>
                      Generate Offer
                    </Form.Button>
                  </Form.Field>
                </Form.Group>
              </Form>
            )}
            {noDealersForAuction && (
              <Message>
                No dealers found for Auction Access # {auctionAccessNumber}
              </Message>
            )}

            {!isEmpty(flatRates) && (
              <FlatRatesList
                onSubmitHandler={onSubmitHandler}
                auctionAccessNumber={auctionAccessNumber}
                govtLast4={govtLast4}
                dealers={dealers}
                milesSelected={milesSelected}
                daysSelected={daysSelected}
                psiEligible={psiEligible}
                daysPsi={daysPsi}
                flatRates={flatRates}
                selectedflatRates={selectedflatRates}
                buyerInformation={buyerInformation}
                productSelected={productSelected}
                productId={productId}
                protductType={protductType}
                productName={productName}
                palv={palv}
                error={error}
              />
            )}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {(submitting || stateSubmitting) && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

NewFlatRateOffer.propTypes = {
  client: PropTypes.shape({
    query: PropTypes.func,
  }),
  data: PropTypes.shape({
    products: PropTypes.array,
  }),
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

const productGraphqlData = graphql(productMasterQuery);
export default compose(
  withApollo,
  productGraphqlData,
  withRouter
)(NewFlatRateOffer);
